import PropTypes from 'prop-types';

export default PropTypes.shape({
  text: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
  newWindow: PropTypes.bool,
});
